module.exports = __webpack_public_path__ + "241f79e122e434abeebc01dbeaa5d664.svg";